//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { ALTERNATE_TOASTS } from '@legacy-components/common/toast-notifications/toastNotificationsConstants';
import {
  IToastNotification,
  ToastType,
} from '@legacy-components/common/toast-notifications/toastNotificationsModel';
import { CONTACT_SUPPORT_MESSAGE } from '@like2buy-v2/Like2BuyV2UIConstants';
import { SocialNetwork } from '@models/SocialNetwork';

const baseToast = {
  options: {
    toastTemplate: ALTERNATE_TOASTS.NEW_TOAST,
  },
};

export const loadLike2BuyV2CustomizationsFailedToast = (
  network: SocialNetwork,
): IToastNotification => ({
  ...baseToast,
  title: 'Failed to Load Like2Buy Customizations',
  message: `We were unable to load your existing ${network} Like2Buy customizations. ${CONTACT_SUPPORT_MESSAGE}`,
  type: ToastType.ERROR,
});

export const saveLike2BuyV2CustomizationsFailedToast = (
  network: SocialNetwork,
): IToastNotification => ({
  ...baseToast,
  title: 'Failed to Save Like2Buy Customizations',
  message: `We were unable to save your ${network} Like2Buy customizations. ${CONTACT_SUPPORT_MESSAGE}`,
  type: ToastType.ERROR,
});

export const digestLike2BuyV2CustomizationsBannerFailedToast = (
  network: SocialNetwork,
): IToastNotification => ({
  ...baseToast,
  title: 'Failed to Upload Like2Buy Customizations Banner',
  message: `We were unable to upload your ${network} Like2Buy store's customized banner. ${CONTACT_SUPPORT_MESSAGE}`,
  type: ToastType.ERROR,
});

export const saveLike2BuyV2CustomizationsSucceededToast = (
  network: SocialNetwork,
): IToastNotification => ({
  ...baseToast,
  title: 'Customizations Saved',
  message: `Customizations saved successfully. Changes may take a few minutes to appear in your ${network} Like2Buy store.`,
  type: ToastType.SUCCESS,
});
